<template>
  <li class="billing__lesson b_lesson"
      :class="[
        {'is_past': isPast ,
        'is_transfered': !lesson.is_regular,
        'is_missed': lesson.is_missed,
        'is_workingoff': lesson.is_workingoff,
        'is_bonus': lesson.is_bonus,
        },
    ]"
  >
    <div class="b_lesson__date">
      <div class="b_lesson__icons">
        <i class="fas fa-check success" v-if="isPast && !lesson.is_missed"></i>
        <i class="fas fa-clock warning" v-if="lesson.is_workingoff"></i>
        <i class="fas fa-times danger" v-if="lesson.is_missed"></i>
        <i class="fas fa-random warning" v-if="!lesson.is_regular && !lesson.is_workingoff"></i>
        <i class="fas fa-gift success" v-if="lesson.is_bonus"></i>
      </div>
      {{ date }}
      <br>
      {{ day }} {{ time }}
    </div>
    <!--<div class="b_lesson__status">
      <i class="fas fa-check success"></i>
    </div>-->
  </li>
</template>

<script>
export default {
  name: "lesson",
  data() {
    return {
      moment_date: ''
    }
  },
  computed: {
    date() {
      if (this.moment_date) return this.moment_date.format('DD.MM');
    },
    day() {
      if (this.moment_date) return this.moment_date.format('dd');
    },
    isPast() {
      return moment().isAfter(this.moment_date);
    },
    time(){
      return moment(this.lesson.time, 'HH:mm:ss').format('HH:mm');
    }
  },
  props: {
    lesson: ''
  },
  methods: {},
  mounted() {
    this.moment_date = moment(this.lesson.date + ' ' + this.lesson.time, 'YYYY-MM-DD HH:mm');
  }
}
</script>